import { useEffect, useState } from "react";
import CheckboxComponent from "@/components/Checkbox";
import Input from "@/components/Input";
import { SearchIcon } from "@/icons";

interface Option {
  id: number;
  title: string;
}

interface FilterProps {
  type: string;
  title: string;
  icon?: any;
  options: Option[];
  isSearchable?: boolean;
  searchPlaceHolder?: string;
  onFilter: (type: string, id: number, isChecked: boolean) => void;
  checkedId: number | null;
  className?: string;
}

const Filter: React.FC<FilterProps> = ({
  type,
  title,
  icon,
  options,
  isSearchable = false,
  searchPlaceHolder = "",
  onFilter,
  checkedId,
  className,
}) => {
  const [searchText, setSearchText] = useState<string>("");
  const [filterOptions, setFilteredOptions] = useState<Option[]>([]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    if (searchText) {
      const newFilteredOptions = options.filter((option) =>
        option.title.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredOptions(newFilteredOptions);
    } else {
      setFilteredOptions(options);
    }
  }, [searchText, options]);

  const handleSearchTextChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchText(event.target.value);
  };

  return (
    <div className={`filter ${className ? className : ""}`}>
      <div className="filter-title">
        {icon}
        <span>{title}</span>
      </div>
      {isSearchable && (
        <Input
          icon={<SearchIcon className={undefined} />}
          value={searchText}
          onChange={handleSearchTextChange}
          placeholderText={searchPlaceHolder}
          className={undefined}
          disablePasswordToggle={undefined}
          onClick={undefined}
          labelText={undefined}
          type={undefined}
          info={undefined}
          required={undefined}
          errorMessage={undefined}
        />
      )}
      <div className="filter-content">
        {filterOptions &&
          filterOptions.map((item, index) => (
            <div key={`${title}-${index}`}>
              <CheckboxComponent
                setChecked={(isChecked: boolean) =>
                  onFilter(type, item.id, isChecked)
                }
                checked={checkedId === item.id}
                text={item.title}
                backgroundColor={"white"}
                color={"#092c4c"}
                borderColor={"#7E92A2"}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Filter;
